import { Component, Vue, Prop } from 'vue-property-decorator'
import vSelect from 'vue-select'
import Form from '../Form/index.vue'
import fetch from '@/helpers/fetch'

@Component({
	components: {
		vSelect,
		Form,
	},
	mixins: [],
})
export default class CalcSubjects extends Vue {
	@Prop() readonly id
	@Prop() readonly title
	@Prop() readonly buttonText
	@Prop() readonly onSubmit
	@Prop() readonly model
	@Prop() readonly options
	@Prop({ default: false }) readonly modalLoading
}
